import { Component, HostListener, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Angulartics2Matomo } from 'angulartics2';
import { ChangeDetectionInfoComponent } from '@entscheidungsnavi/widgets/change-detection-info';
import * as Sentry from '@sentry/angular';

@Component({
  selector: 'dt-root',
  templateUrl: './cockpit.component.html',
  styleUrls: ['./cockpit.component.scss'],
  imports: [RouterOutlet, ChangeDetectionInfoComponent],
})
export class CockpitComponent {
  private _ = inject(Sentry.TraceService);
  private angulartics = inject(Angulartics2Matomo);

  changeDetectionTrackingOpen = false;

  constructor() {
    this.angulartics.startTracking();
  }

  @HostListener('window:keydown', ['$event'])
  keydown(event: KeyboardEvent) {
    if (event.key === 'a' && event.ctrlKey && event.altKey) {
      this.changeDetectionTrackingOpen = !this.changeDetectionTrackingOpen;
    }
  }
}
